import React from "react"
import smoothscroll from "smoothscroll-polyfill"

import "~/styles/index.css"
import Provider from "~/store"

smoothscroll.polyfill()

export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>
